import React from 'react';
import { CpsGridView } from '@cs-cms/types';
import { GlobalFiltersEditor } from '../GlobalFiltersEditor';
import { PrivateView } from './privateView/PrivateView';
import { ReadOnlyView } from './ReadOnlyView';
import { ViewHeader } from './privateView/viewHeader/ViewHeader';
import { ViewsManagementHeaderWrapper } from '../ViewsManagementHeader';
import { findViewById } from './userViewsUtils';

interface UserViewsSelectedViewProps {
  views: CpsGridView[];
  selectedView: number | null | undefined;
}

export const UserViewsSelectedView: React.FC<UserViewsSelectedViewProps> = ({ views, selectedView }) => {
  const currentView = findViewById(views, selectedView);

  if (!currentView) {
    return null;
  }

  if (currentView.isPrivate) {
    return (
      <>
        <GlobalFiltersEditor />
        <div>
          <ViewsManagementHeaderWrapper>
            <ViewHeader viewName={currentView.name} />
          </ViewsManagementHeaderWrapper>
          <PrivateView />
        </div>
      </>
    );
  }

  return (
    <div>
      <ViewsManagementHeaderWrapper>{currentView.name}</ViewsManagementHeaderWrapper>
      <ReadOnlyView />
    </div>
  );
};
